import { z } from 'zod';
import { ERROR_CODES } from './errors';
import type { Snapshot } from './types';

/** Server -> client event names. */
export const SERVER_EVENTS = {
  snapshot: 'snapshot',
  identity: 'identity',
  error: 'error',
} as const;

/** Client -> server event name. All intents travel on one channel. */
export const CLIENT_EVENT_INTENT = 'intent';

export const IdentitySchema = z.object({
  playerId: z.string(),
  playerToken: z.string(),
});
export type Identity = z.infer<typeof IdentitySchema>;

export const WireErrorSchema = z.object({
  code: z.enum(ERROR_CODES),
  message: z.string(),
  /** Echoed back so a client can correlate a failure with what it sent. */
  intentType: z.string().optional(),
});
export type WireError = z.infer<typeof WireErrorSchema>;

/** Handshake auth presented on the socket connection. */
export const HandshakeAuthSchema = z.object({
  roomToken: z.string().min(1),
  playerToken: z.string().min(1).optional(),
  adminToken: z.string().min(1).optional(),
  /** Set by the /projector route. Read-only, issues no intents. */
  projector: z.boolean().optional(),
});
export type HandshakeAuth = z.infer<typeof HandshakeAuthSchema>;

export interface ServerToClientEvents {
  snapshot: (s: Snapshot) => void;
  identity: (i: Identity) => void;
  error: (e: WireError) => void;
}
